import React from "react";

export default function PreviewFormModalEmptyState() {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center py-5 px-3 text-center rounded-2 border bg-light"
      role="status"
    >
      <i
        className="bi bi-inbox text-muted mb-2"
        style={{ fontSize: "2.5rem" }}
        aria-hidden
      />
      <p className="m-0 fw-medium text-muted">No details to show</p>
      <p className="m-0 small text-muted mt-1">
        All relevant fields are hidden or empty.
      </p>
    </div>
  );
}
